import { DashDonationType, WageAndTravelReimbursementRequestStatus } from '@nkr/enums/index';

export type ViewStep = 'list' | 'review';

export interface IItem {
    name: string,
    alias: string,
    weeks: number[],
    requestId: number,
    status: WageAndTravelReimbursementRequestStatus,
    additionalWeeksReason?: number,
    additionalWeeksReasonOther?: string,
    additionalWeeksJobDescription?: string,
    organType: DashDonationType,
    hasActiveComplicationsReport?: boolean
}
